export const currentYear = new Date().getFullYear();
export const filterYear = currentYear -1;